import PropTypes from 'prop-types';
/* eslint react/forbid-prop-types: 0 */

export default PropTypes.any;